"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnorderedList = exports.ListItem = void 0;
var _stitches = require("../../../../stitches.config");
var UnorderedList = (0, _stitches.styled)('ul', {
  listStyleType: 'none',
  paddingLeft: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 10
});
exports.UnorderedList = UnorderedList;
var ListItem = (0, _stitches.styled)('li', {
  padding: 0
});
exports.ListItem = ListItem;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');